// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { secondsToMilliseconds as fn } from "../secondsToMilliseconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const secondsToMilliseconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default secondsToMilliseconds;
